import { useEffect } from "react";
import { _ProjectProducts, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import useModal, { MODAL_md, MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { InputMoney } from "../../../theme/Input/InputMoney";

interface Props {
    _IDProject: number;
}

export const ProjectProducts = ({ _IDProject }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_ProjectProducts)

    useEffect(() => {
        getLista()
    }, [_IDProject])

    const getLista = () => {
        const props = {
            IDProject: _IDProject,
            State: 1
        }
        instance.getProjectProductsCatalogPorPropiedades(props, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDProjectProducts', visible: true, mask: MASK_NUMBER },
        { title: 'Proyecto', property: 'IDProject', visible: true, mask: MASK_NUMBER },
        { title: 'Producto', property: 'IDProduct', visible: true },
        { title: 'Valor Unitario', property: 'UnitaryValue', visible: true, mask: MASK_MONEY },
    ]

    const modalConfirm = useModal("Eliminar Producto", MODAL_SM);
    const modalEditar = useModal("Agregar Proyecto", MODAL_md);

    const create = () => {
        setBean({
            IDProject: _IDProject,
            State: 1,
            IDEmployee: _single.getAccountID()
        });

        modalEditar.setModal({ ...modalEditar.modal, "view": true, name: "Crear Proucto en la lista" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modalEditar.setModal({ ...modalEditar.modal, "view": true, name: "Editar Proucto en la lista" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalConfirm.setModal({ ...modalConfirm.modal, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const editaItem = () => {
        instance.updateProjectProducts(bean).then(
            (resp) => {
                modalEditar.close();
                getLista();
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        instance.deleteProjectProducts(bean.IDProjectProducts).then(
            (resp) => {
                modalConfirm.close();
                getLista()
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} />


                <Modal modal={modalEditar.modal} updateModal={modalEditar.setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <SelectProductEditor onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct, "UnitaryValue": e.SalesValue }) }} label="Producto de Venta" />
                        </div>
                        <div className="col-12">
                            <label>Costo Unitario</label>
                            <InputMoney _label=" " _value={bean.UnitaryValue} onChange={(e) => { setBean({ ...bean, "UnitaryValue": e }) }} />
                        </div>
                    </div>
                </Modal>


                <ModalConfirm modal={modalConfirm.modal} updateModal={modalConfirm.setModal} eventModal={deleteItem}>
                    <strong>Eliminar Producto</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}